var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompanyLogoFilled = function SvgCompanyLogoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 143 144"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#company-logo-filled_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 143,
    y: 0.291,
    fill: "#F2F2F6",
    rx: 71.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA3B8",
    d: "M19.212 31.732H17.91c-.718 0-1.301.583-1.301 1.302v9.112c0 .72.583 1.302 1.301 1.302h1.302c.72 0 1.302-.583 1.302-1.302v-9.112c0-.719-.583-1.302-1.302-1.302M24.68 27.048h-1.302c-.719 0-1.302.583-1.302 1.302v9.112c0 .719.583 1.301 1.302 1.301h1.302c.719 0 1.301-.582 1.301-1.301V28.35c0-.72-.582-1.302-1.301-1.302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F54B67",
    fillRule: "evenodd",
    d: "M10.1 43.672 50.844 21.71v121.582H10.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#951730",
    d: "M75.968 21.709H50.844v121.582h25.124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E305F",
    fillRule: "evenodd",
    d: "M29.756 127.54h1.562a3.905 3.905 0 0 1 3.906 3.905v11.846H25.85v-11.846a3.905 3.905 0 0 1 3.905-3.905",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C2964",
    d: "M19.473 52.3h-3.124a3.124 3.124 0 0 0-3.125 3.124v4.686a3.124 3.124 0 0 0 3.125 3.124h3.124a3.124 3.124 0 0 0 3.124-3.124v-4.686a3.124 3.124 0 0 0-3.124-3.124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA3B8",
    d: "M19.473 89.92h-3.124a3.124 3.124 0 0 0-3.125 3.124v4.686a3.124 3.124 0 0 0 3.125 3.124h3.124a3.124 3.124 0 0 0 3.124-3.124v-4.686a3.124 3.124 0 0 0-3.124-3.124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E305F",
    d: "M19.473 71.176h-3.124a3.124 3.124 0 0 0-3.125 3.124v4.686a3.124 3.124 0 0 0 3.125 3.124h3.124a3.124 3.124 0 0 0 3.124-3.124V74.3a3.124 3.124 0 0 0-3.124-3.124M32.1 52.3h-3.125a3.124 3.124 0 0 0-3.124 3.124v4.686a3.124 3.124 0 0 0 3.124 3.124H32.1a3.124 3.124 0 0 0 3.125-3.124v-4.686a3.124 3.124 0 0 0-3.125-3.124M32.1 89.92h-3.125a3.124 3.124 0 0 0-3.124 3.124v4.686a3.124 3.124 0 0 0 3.124 3.124H32.1a3.124 3.124 0 0 0 3.125-3.124v-4.686a3.124 3.124 0 0 0-3.125-3.124M32.1 71.176h-3.125a3.124 3.124 0 0 0-3.124 3.124v4.686a3.124 3.124 0 0 0 3.124 3.124H32.1a3.124 3.124 0 0 0 3.125-3.124V74.3a3.124 3.124 0 0 0-3.125-3.124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA3B8",
    d: "M44.596 52.3h-3.124a3.124 3.124 0 0 0-3.124 3.124v4.686a3.124 3.124 0 0 0 3.124 3.124h3.124a3.124 3.124 0 0 0 3.124-3.124v-4.686a3.124 3.124 0 0 0-3.124-3.124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E305F",
    d: "M44.596 89.92h-3.124a3.124 3.124 0 0 0-3.124 3.124v4.686a3.124 3.124 0 0 0 3.124 3.124h3.124a3.124 3.124 0 0 0 3.124-3.124v-4.686a3.124 3.124 0 0 0-3.124-3.124M44.596 71.176h-3.124a3.124 3.124 0 0 0-3.124 3.124v4.686a3.124 3.124 0 0 0 3.124 3.124h3.124a3.124 3.124 0 0 0 3.124-3.124V74.3a3.124 3.124 0 0 0-3.124-3.124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C2964",
    d: "M67.637 52.3h-8.331a3.645 3.645 0 0 0-3.645 3.645v3.645a3.645 3.645 0 0 0 3.645 3.644h8.33a3.645 3.645 0 0 0 3.646-3.645v-3.644a3.645 3.645 0 0 0-3.645-3.645M67.637 89.92h-8.331a3.645 3.645 0 0 0-3.645 3.645v3.645a3.644 3.644 0 0 0 3.645 3.644h8.33a3.644 3.644 0 0 0 3.646-3.644v-3.645a3.645 3.645 0 0 0-3.645-3.645M67.637 29.65h-8.331a3.645 3.645 0 0 0-3.645 3.644v7.55a3.645 3.645 0 0 0 3.645 3.645h8.33a3.645 3.645 0 0 0 3.646-3.645v-7.55a3.645 3.645 0 0 0-3.645-3.645M67.637 71.176h-8.331a3.645 3.645 0 0 0-3.645 3.645v3.645a3.645 3.645 0 0 0 3.645 3.644h8.33a3.645 3.645 0 0 0 3.646-3.644V74.82a3.645 3.645 0 0 0-3.645-3.645"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E305F",
    d: "M19.473 108.796h-3.124a3.124 3.124 0 0 0-3.125 3.124v4.686a3.124 3.124 0 0 0 3.125 3.124h3.124a3.124 3.124 0 0 0 3.124-3.124v-4.686a3.124 3.124 0 0 0-3.124-3.124M19.473 127.669h-3.124a3.124 3.124 0 0 0-3.125 3.124v4.686a3.124 3.124 0 0 0 3.125 3.125h3.124a3.125 3.125 0 0 0 3.124-3.125v-4.686a3.124 3.124 0 0 0-3.124-3.124M32.1 108.796h-3.125a3.124 3.124 0 0 0-3.124 3.124v4.686a3.124 3.124 0 0 0 3.124 3.124H32.1a3.124 3.124 0 0 0 3.125-3.124v-4.686a3.124 3.124 0 0 0-3.125-3.124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C2964",
    d: "M44.596 108.796h-3.124a3.124 3.124 0 0 0-3.124 3.124v4.686a3.124 3.124 0 0 0 3.124 3.124h3.124a3.124 3.124 0 0 0 3.124-3.124v-4.686a3.124 3.124 0 0 0-3.124-3.124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E305F",
    d: "M44.596 127.669h-3.124a3.124 3.124 0 0 0-3.124 3.124v4.686a3.124 3.124 0 0 0 3.124 3.125h3.124a3.124 3.124 0 0 0 3.124-3.125v-4.686a3.124 3.124 0 0 0-3.124-3.124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C2964",
    d: "M67.637 108.796h-8.331a3.645 3.645 0 0 0-3.645 3.645v3.645a3.644 3.644 0 0 0 3.645 3.644h8.33a3.644 3.644 0 0 0 3.646-3.644v-3.645a3.645 3.645 0 0 0-3.645-3.645M67.637 127.669h-8.331a3.645 3.645 0 0 0-3.645 3.645v3.645a3.645 3.645 0 0 0 3.645 3.645h8.33a3.645 3.645 0 0 0 3.646-3.645v-3.645a3.645 3.645 0 0 0-3.645-3.645"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E305F",
    d: "M108.652 105.198H62.915v38.093h45.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C2964",
    d: "M130.731 105.198h-22.079v38.093h22.079zM90.515 128.094h-9.463v15.198h9.463z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA3B8",
    d: "M77.11 127.896h-9.463v9.473h9.462zM77.11 111.908h-9.463v9.474h9.462zM103.92 127.896h-9.463v9.473h9.463zM103.92 111.908h-9.463v9.474h9.463zM90.515 111.908h-9.463v9.474h9.463z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F54B67",
    d: "M124.423 111.908h-9.463v9.474h9.463z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA3B8",
    d: "M124.423 127.896h-9.463v9.473h9.463zM88.263 95.33h-4.96a2.25 2.25 0 0 0-2.251 2.25v4.972a2.25 2.25 0 0 0 2.251 2.251h4.96a2.25 2.25 0 0 0 2.252-2.251v-4.971a2.25 2.25 0 0 0-2.252-2.252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C2964",
    d: "M116.143 85.656H84.601v19.738h31.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E305F",
    d: "M94.457 85.656H62.915v19.738h31.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA3B8",
    d: "M77.11 88.225h-9.463v14.408h9.462zM90.515 88.225h-9.463v14.408h9.463z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F54B67",
    d: "M117.917 82.5h-23.46v3.158h23.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA3B8",
    d: "M111.412 102.237H94.457v3.158h16.955z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F54B67",
    d: "M132.9 102.237h-21.489v3.158H132.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA3B8",
    d: "M96.626 82.5H62.915v3.158h33.711z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 142,
    x: 0.5,
    y: 0.791,
    stroke: "#FF2458",
    rx: 71
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "company-logo-filled_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 143,
    y: 0.291,
    fill: "#fff",
    rx: 71.5
  })))));
};
export default SvgCompanyLogoFilled;